<template>
  <div class="noticias-container">
    <h2>Notícias</h2>

    <Carregamento v-if="carregando" />
    <div
      v-else-if="noticias.length === 0"
      class="no-data"
    >
      Nenhuma notícia encontrada.
    </div>
    <div
      v-else
      v-for="noticia in noticias"
      :key="noticia.id"
      class="noticia-card"
    >
      <div class="noticia-header">
        <div class="noticia-header-left">
          <span
            class="badge"
            :class="{
              'badge-pendente':
                noticia.statusDescricao === 'AGUARDANDO_AUTORIZACAO',
              'badge-aprovada': noticia.statusDescricao === 'PUBLICADA',
              'badge-rejeitada': noticia.statusDescricao === 'CANCELADA',
            }"
          >
            {{ noticia.statusDescricao }}
          </span>
          <span class="noticia-titulo">{{ noticia.titulo }}</span>
        </div>
        <button
          class="btn-detalhes"
          @click="verDetalhes(noticia)"
        >
          Detalhes
        </button>
      </div>

      <p class="noticia-descricao">{{ noticia.texto }}</p>

      <div class="noticia-footer">
        <div class="palavras-chave">
          <span
            v-for="palavra in noticia.palavrasChaves"
            :key="palavra"
            class="tag"
          >
            {{ palavra }}
          </span>
        </div>
        <span class="publicado-por"
          >Publicado por: {{ noticia.autorPublicacaoNome }}</span
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import noticiaService from "@/service/noticiaService";
import { useRouter } from "vue-router";
import Carregamento from "@/components/common/Carregamento.vue";

const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});

const router = useRouter();
const noticias = ref([]);
const carregando = ref(true);

async function carregarNoticias() {
  try {
    carregando.value = true;
    const response = await noticiaService.getNoticiasByAbrangenciaAndStatus(
      0,
      1000,
      props.acaoId,
      false,
      true
    );
    if (response && response.noticias) {
      noticias.value = response.noticias;
    }
  } catch (error) {
    console.error("Erro ao carregar notícias:", error);
  } finally {
    carregando.value = false;
  }
}

function verDetalhes(noticia) {
  router.push({
    name: "aceitar-noticia-central-coordenacao",
    params: { id: props.acaoId, noticiaId: noticia.id },
  });
}

onMounted(() => {
  carregarNoticias();
});
</script>

<style scoped>
h2 {
  color: var(--azul-escuro, #1a1a6e);
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.noticias-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: #333;
}

.loading,
.no-data {
  text-align: center;
  padding: 2rem;
  color: #666;
}

/* Card */
.noticia-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  background-color: #f5f6fa;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* Header do card */
.noticia-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.noticia-header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.noticia-titulo {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1a1a1a;
}

/* Badges de status */
.badge {
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  color: white;
}

.badge-pendente {
  background-color: #f5a623;
}

.badge-aprovada {
  background-color: #27ae60;
}

.badge-rejeitada {
  background-color: #e74c3c;
}

/* Botão detalhes */
.btn-detalhes {
  padding: 5px 18px;
  background-color: var(--azul-escuro, #1a1a6e);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 200ms;
  flex-shrink: 0;
}

.btn-detalhes:hover {
  opacity: 0.85;
}

/* Descrição */
.noticia-descricao {
  font-size: 0.85rem;
  color: #555;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Footer do card */
.noticia-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.palavras-chave {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.tag {
  background-color: #dde1f0;
  color: #1a1a6e;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
}

.publicado-por {
  font-size: 0.78rem;
  color: #888;
  white-space: nowrap;
}
</style>

<style scoped>
h2 {
  color: var(--azul-escuro, #1a1a6e);
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.noticias-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: #333;
}

/* Card */
.noticia-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  background-color: #f5f6fa;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* Header do card */
.noticia-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.noticia-header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.noticia-titulo {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1a1a1a;
}

/* Badges de status */
.badge {
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  color: white;
}

.badge-pendente {
  background-color: #f5a623;
}

.badge-aprovada {
  background-color: #27ae60;
}

.badge-rejeitada {
  background-color: #e74c3c;
}

/* Botão detalhes */
.btn-detalhes {
  padding: 5px 18px;
  background-color: var(--azul-escuro, #1a1a6e);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 200ms;
  flex-shrink: 0;
}

.btn-detalhes:hover {
  opacity: 0.85;
}

/* Descrição */
.noticia-descricao {
  font-size: 0.85rem;
  color: #555;
  margin: 0;
  line-height: 1.4;
}

/* Footer do card */
.noticia-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.palavras-chave {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.tag {
  background-color: #dde1f0;
  color: #1a1a6e;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
}

.publicado-por {
  font-size: 0.78rem;
  color: #888;
  white-space: nowrap;
}
</style>
